import { noopRenderer } from '@fluentui/react-northstar-styles-renderer';
import { emptyTheme } from '@fluentui/styles';
import * as React from 'react';
export var defaultPerformanceFlags = {
  enableSanitizeCssPlugin: process.env.NODE_ENV !== 'production',
  enableStylesCaching: true,
  enableVariablesCaching: true,
  enableBooleanVariablesCaching: false
};
export var defaultContextValue = {
  // A default value for `rtl` is undefined to let compute `Provider` a proper one
  rtl: undefined,
  disableAnimations: false,
  performance: defaultPerformanceFlags,
  renderer: noopRenderer,
  theme: emptyTheme,
  telemetry: undefined,
  target: undefined
};
var FluentContext = /*#__PURE__*/React.createContext(defaultContextValue);
export function useFluentContext() {
  return React.useContext(FluentContext);
}
export var Unstable_FluentContextProvider = FluentContext.Provider;
//# sourceMappingURL=context.js.map
